import { Box, Dialog, DialogContent, DialogContentText, DialogTitle, Divider, Typography, Button } from '@mui/material';
import React, { useMemo, useState, useCallback } from 'react';
import LogsTable from '../../AppGrid/LogsTable';
import strings from '../../Globalization';
import Connection from '../../services/Connection';
import util from '../../util';
import consts from '../../consts';

const { nonParsableTopics } = consts;
const { showError } = util;

const deviceTypeIndex = 3;

const needUTF16Parsing = (topicArray) => {
	return (['ISA', 'CT', 'RAER'].includes(topicArray[deviceTypeIndex])
		&& ['scopefile', 'userfile', 'deletespecificendoprofile'].includes(topicArray[topicArray.length - 1]));
}

const LogsList = () => {
	const [activeRecord, setActiveRecord] = useState(null);
	const topicArray = activeRecord && activeRecord.topic && activeRecord.topic.split('/') || [];
	const subTopic = topicArray && topicArray[topicArray.length - 1] || "";
	const encoding = needUTF16Parsing(topicArray) ? 'utf16le' : 'utf8';
	const [canParse, setCanParse] = useState(true);

	const handleOnOpenForm = ({ record }) => {
		const topic = record?.topic;
		const subTopic = topic.split('/')[4];
		setActiveRecord(record);
		const data = record?.data;
		let isParsable = true;
		try {
			JSON.parse(data);
			isParsable = !nonParsableTopics.includes(subTopic);
		} catch (error) {
			isParsable = false;
		}
		setCanParse(isParsable);
	};
	const data = useMemo(() => {
		let str = activeRecord?.data;
		const topic = activeRecord?.topic;
		if (activeRecord?.data) {
			try {
				const parsedData = JSON.parse(activeRecord.data);
				if ((parsedData || parsedData.data).hasOwnProperty('payload')) {
					const payloadIndex = subTopic === consts.cyclefileres ? consts.mqttPayloadEnums.cyclefileresData : consts.mqttPayloadEnums.cyclefileData;
					const { payload } = parsedData.hasOwnProperty('payload') ? parsedData : parsedData.data;
					if (subTopic === consts.unpublishedfiles) {
						setCanParse(false);
					}else if(topic.indexOf('cyclefileres')){
						setCanParse(true);
					} else if (!Array.isArray(payload) || payload.length <= payloadIndex || !payload[payloadIndex][0].hasOwnProperty('v')) {
						setCanParse(false);
					}
				}
				else{
					setCanParse(false);
				}
				str = JSON.stringify(parsedData, null, 2);
			} catch (error) {
				setCanParse(false)
			}
		}
		return str?.replace(/></g, '>\n<');
	}, [activeRecord?.data]);

	const onParsePayload = useCallback(async () => {
		const formData = new FormData();
		formData.append("action", 'otherAction');
		formData.append("otherAction", 'handleParsePayload');
		formData.append('payload', data);
		formData.append('subTopic', subTopic);
		formData.append('encoding', encoding);
		let errorMessage = "";
		try {
			const response = await fetch(`${Connection.Logs}`, {
				method: 'POST',
				body: formData
			});
			const { success, data: parsedData, info } = await response.json();
			if (success) {
				setActiveRecord({ data: parsedData });
				return setCanParse(false);
			} else {
				errorMessage = info;
			}
		} catch (err) {
			errorMessage = strings.ParsePayloadFailed;
		} finally {
			if (errorMessage) {
				showError(strings[errorMessage], strings.Info, 'info');
			}
		}
	},[data, subTopic, encoding]);

	return (
		<Box>
			<LogsTable onOpenForm={handleOnOpenForm} />
			<Dialog
				open={!!activeRecord}
				sx={{
					zIndex: theme => theme.zIndex.tooltip,
					'& .MuiDialog-paper': {
						maxWidth: '55vw !important',
						width: '55vw !important',
						maxHeight: '60vh !important'
					},
					'& .MuiDialogContentText-root': {
						border: (theme) => `1px solid ${theme.palette.divider}`,
						borderRadius: (theme) => theme.spacing(0.5),
						backgroundColor: 'action.selected',
						padding: (theme) => theme.spacing(0, 2),
						'& pre': {
							overflowX: 'auto'
						}
					}
				}}
				disableEscapeKeyDown
			>
				<DialogTitle sx={{ display: 'flex', flexDirection: 'row' }}>
					<Typography variant="body1" color="primary" sx={{ flex: 1 }}>
						{strings.Payload}
					</Typography>
					{
						canParse && <Button
							size="small"
							color="primary"
							variant="outlined"
							sx={{
								mx: 1,
								backgroundColor: '#1C84C6',
								color: '#fff',
								border: 'none',
								'&:hover': {
									background: '#1C84C6'
								}
							}} onClick={onParsePayload}>
							{strings.PreviewPayload}
						</Button>
					}
					<Button
						onClick={() => setActiveRecord(null)}
						title={strings.Close}
						color="error"
						variant="contained"
						size="small"
						sx={{
							px: 1,
							fontSize: 14,
							textTransform: 'uppercase',
							fontWeight: 'bold',
						}}
					>
						{strings.Close}
					</Button>

				</DialogTitle >
				<Divider />
				<DialogContent>
					<Typography component="div" variant="body1" color="textSecondary">
						<pre style={{ backgroundColor: '#f0f0f0', padding: '16px', borderRadius: '4px', overflow: 'auto' }}>{data || ''}</pre>
					</Typography>
				</DialogContent>
			</Dialog >
		</Box >
	);
};

export default LogsList;
